export default __webpack_public_path__ + "static/alienvault-979930e346835a37519f37cf24e2f74a.png";